module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "container",
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticClass: "tile-image",
    attrs: {
      "src": _vm.src
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.content))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ffe0a52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/tile.vue
// module id = 842
// module chunks = 34